import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { useNavigate } from "react-router-dom";
import { Space } from "antd";

import * as Common from "../commons/common";
import * as TypeDTO from "../commons/typeDTO";
import * as Request from "../commons/request";

import locked from "../assets/images/smartkey/locked.svg";
import unlocked from "../assets/images/smartkey/unlocked.svg";
import lockedYaxingCar from "../assets/images/smartkey/locked-yaxing-car.svg";
import unlockedYaxingCar from "../assets/images/smartkey/unlocked-yaxing-car.svg";
import closed from "../assets/images/smartkey/closed.svg";
import opened from "../assets/images/smartkey/opened.svg";

import styles from "./Smartkey.module.css";

const btnAnim = {
    whileTap: { scale: 0.75 },
};

function Smartkey({
    activeCar,
    onSmartkeyActionError,
    onHandleDoor,
}: {
    activeCar?: TypeDTO.CarOwnerDto;
    onSmartkeyActionError?: (message: string) => void;
    onHandleDoor?: (isActive: boolean, doorType: Common.DoorType) => void;
}) {
    const navigate = useNavigate();

    const requestAxiosCloseDoor = async (carId: number) => {
        const response = await utilAxiosWithAuth().post(Request.DOOR_CAR_URL + carId + Request.DOOR_CAR_CLOSE_URL);
        return response.data;
    };

    const {
        loading: loadingCloseDoor,
        error: errorCloseDoor,
        data: resultCloseDoor,
        execute: requestCloseDoor,
    } = useAsyncAxios(requestAxiosCloseDoor);

    useEffect(() => {
        if (!resultCloseDoor) return;
        console.log("resultCloseDoor", resultCloseDoor);
    }, [resultCloseDoor]);

    useEffect(() => {
        if (!errorCloseDoor) return;

        console.log("errorCloseDoor", errorCloseDoor);
        onSmartkeyActionError && onSmartkeyActionError("네트워크에 접속할 수 없습니다. \n연결상태를 확인해 주세요.");
    }, [errorCloseDoor]);

    const requestAxiosOpenDoor = async (carId: number) => {
        const response = await utilAxiosWithAuth().post(Request.DOOR_CAR_URL + carId + Request.DOOR_CAR_OPEN_URL);
        return response.data;
    };

    const { error: errorOpenDoor, data: resultOpenDoor, execute: requestOpenDoor } = useAsyncAxios(requestAxiosOpenDoor);

    useEffect(() => {
        if (!resultOpenDoor) return;

        console.log("resultOpenDoor", resultOpenDoor);
    }, [resultOpenDoor]);

    useEffect(() => {
        if (!errorOpenDoor) return;

        console.log("errorOpenDoor", errorOpenDoor);
        onSmartkeyActionError && onSmartkeyActionError("네트워크에 접속할 수 없습니다. \n연결상태를 확인해 주세요.");
    }, [errorOpenDoor]);

    const requestAxiosCloseSwingDoor = async (carId: number) => {
        const response = await utilAxiosWithAuth().post(Request.DOOR_CAR_URL + carId + Request.SWING_DOOR_CAR_CLOSE_URL);
        return response.data;
    };

    const {
        loading: loadingCloseSwingDoor,
        error: errorCloseSwingDoor,
        data: resultCloseSwingDoor,
        execute: requestCloseSwingDoor,
    } = useAsyncAxios(requestAxiosCloseSwingDoor);

    useEffect(() => {
        if (!resultCloseSwingDoor) return;
        console.log("resultCloseSwingDoor", resultCloseSwingDoor);
    }, [resultCloseSwingDoor]);

    useEffect(() => {
        if (!errorCloseSwingDoor) return;

        console.log("errorCloseSwingDoor", errorCloseSwingDoor);
        onSmartkeyActionError && onSmartkeyActionError("네트워크에 접속할 수 없습니다. \n연결상태를 확인해 주세요.");
    }, [errorCloseSwingDoor]);

    const requestAxiosOpenSwingDoor = async (carId: number) => {
        const response = await utilAxiosWithAuth().post(Request.DOOR_CAR_URL + carId + Request.SWING_DOOR_CAR_OPEN_URL);
        return response.data;
    };

    const {
        loading: loadingOpenSwingDoor,
        error: errorOpenSwingDoor,
        data: resultOpenSwingDoor,
        execute: requestOpenSwingDoor,
    } = useAsyncAxios(requestAxiosOpenSwingDoor);

    useEffect(() => {
        if (!resultOpenSwingDoor) return;
        console.log("resultOpenSwingDoor", resultOpenSwingDoor);
    }, [resultOpenSwingDoor]);

    useEffect(() => {
        if (!errorOpenSwingDoor) return;

        console.log("errorOpenSwingDoor", errorOpenSwingDoor);
        onSmartkeyActionError && onSmartkeyActionError("네트워크에 접속할 수 없습니다. \n연결상태를 확인해 주세요.");
    }, [errorOpenDoor]);

    const handleLock = () => {
        activeCar && requestCloseDoor(activeCar.car.carId);
    };

    const handleUnlock = () => {
        activeCar && requestOpenDoor(activeCar.car.carId);
    };
    const handleSwingDoorLock = () => {
        activeCar && requestCloseSwingDoor(activeCar.car.carId);
    };

    const handleSwingDoorUnlock = () => {
        activeCar && requestOpenSwingDoor(activeCar.car.carId);
    };

    const handleCarRegisterBtn = () => {
        navigate(Common.PAGE_REGISTER_CAR);
    };

    return (
        <div className={`${styles.smartkeyContainer}`}>
            {activeCar?.car.carId ? (
                !activeCar?.car.doorModuleImei ? (
                    <div className={`${styles.btnWrapper}`}>
                        <motion.button className={styles.registerBtn}>
                            <div className={`${styles.btnText} ${styles.noSmartkey}`}>스마트키를 사용할 수 없는 상태입니다.</div>
                        </motion.button>
                    </div>
                ) : activeCar?.car.hasSwingDoor ? (
                    <>
                        <div className={`${styles.btnWrapper}`}>
                            <button
                                className={styles.lockBtn}
                                onClick={handleLock}
                                onTouchStart={() =>
                                    onHandleDoor && onHandleDoor(true, Common.DoorType.DOOR)
                                }
                                onTouchEnd={() =>
                                    onHandleDoor && onHandleDoor(false, Common.DoorType.DOOR)
                                }
                            >
                                <motion.div
                                    variants={btnAnim}
                                    whileTap="whileTap"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <img width={82} height={50} src={lockedYaxingCar} className={styles.btnIcon} alt="locked padlock" />
                                </motion.div>
                            </button>
                            <button
                                className={styles.lockBtn}
                                onClick={handleUnlock}
                                onTouchStart={() =>
                                    onHandleDoor && onHandleDoor(true, Common.DoorType.DOOR)
                                }
                                onTouchEnd={() =>
                                    onHandleDoor && onHandleDoor(false, Common.DoorType.DOOR)
                                }
                            >
                                <motion.div
                                    variants={btnAnim}
                                    whileTap="whileTap"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <img width={82} height={50} src={unlockedYaxingCar} className={styles.btnIcon} alt="unlocked padlock" />
                                </motion.div>
                            </button>
                        </div>
                        <div className={`${styles.btnWrapper}`}>
                            <button
                                className={styles.lockBtn}
                                onClick={handleSwingDoorLock}
                                onTouchStart={() =>
                                    onHandleDoor && onHandleDoor(true, Common.DoorType.SWING_DOOR)
                                }
                                onTouchEnd={() =>
                                    onHandleDoor && onHandleDoor(false, Common.DoorType.SWING_DOOR)
                                }
                            >
                                <motion.div
                                    variants={btnAnim}
                                    whileTap="whileTap"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <img width={82} height={50} src={closed} className={styles.btnIcon} alt="locked padlock" />
                                </motion.div>
                            </button>
                            <button
                                className={styles.lockBtn}
                                onClick={handleSwingDoorUnlock}
                                onTouchStart={() =>
                                    onHandleDoor && onHandleDoor(true, Common.DoorType.SWING_DOOR)
                                }
                                onTouchEnd={() =>
                                    onHandleDoor && onHandleDoor(false, Common.DoorType.SWING_DOOR)
                                }
                            >
                                <motion.div
                                    variants={btnAnim}
                                    whileTap="whileTap"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                >
                                    <img width={82} height={50} src={opened} className={styles.btnIcon} alt="unlocked padlock" />
                                </motion.div>
                            </button>
                        </div>
                    </>
                ) : (
                    <div className={`${styles.btnWrapper}`}>
                        <button className={styles.lockBtn} onClick={handleLock}>
                            <motion.div
                                variants={btnAnim}
                                whileTap="whileTap"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                            >
                                <img width={43} height={50} src={locked} className={styles.btnIcon} alt="locked padlock" />
                            </motion.div>
                        </button>
                        <button className={styles.lockBtn} onClick={handleUnlock}>
                            <motion.div
                                variants={btnAnim}
                                whileTap="whileTap"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                            >
                                <img width={43} height={50} src={unlocked} className={styles.btnIcon} alt="unlocked padlock" />
                            </motion.div>
                        </button>
                    </div>
                )
            ) : (
                <div className={`${styles.btnWrapper}`}>
                    <motion.button className={styles.registerBtn} whileTap={{ scale: 0.9 }} onClick={handleCarRegisterBtn}>
                        <div className={styles.btnText}>차량 등록</div>
                    </motion.button>
                </div>
            )}
        </div>
    );
}

export default Smartkey;
